import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const vendorAPI = createApi({
    reducerPath: "vendorAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllVendors: builder.mutation({
            query: ({ page, size, search, searchBy, status }) => {
                let apiUrl = `/vendor?page=${page + 1}&size=${size}`;

                if (search) {
                    apiUrl += `&search=${search}`;
                }

                if (searchBy) {
                    apiUrl += `&searchBy=${searchBy}`;
                }

                if (status) {
                    apiUrl += `&status=${status}`;
                }
                
                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["vendor"],
        }),
        getVendorById: builder.mutation({
            query: ({id}) => {
                let apiUrl = `/vendor/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createVendor: builder.mutation({
            query: ({body}) => ({
                url: `/vendor`,
                method: "POST",
                body
            }),
            invalidatesTags: ["vendor"],
        }),
        updateVendor: builder.mutation({
            query: ({ id, body }) => ({
                url: `/vendor/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["vendor"],
        }),
        deleteVendor: builder.mutation({
            query: ({id}) => ({
                url: `/vendor/${id}`,
                method: "DELETE",
                body: {}
            }),
            invalidatesTags: ["vendor"],
        }),

        deactivateVendor: builder.mutation({
            query: ({id, body}) => ({
                url: `/vendor/${id}/deactivate`,
                method: "POST",
                body
            })
        }),
        activateVendor: builder.mutation({
            query: ({id}) => ({
                url: `/vendor/${id}/reactivate`,
                method: "POST",
                body: {}
            })
        }),

        uploadVendorDocument: builder.mutation({
            query: ({id, body}) => ({
                url: `/vendor/${id}/documents`,
                method: "POST",
                body
            })
        }),
        removeVendorDocument: builder.mutation({
            query: ({id, documentId}) => ({
                url: `/vendor/${id}/documents/${documentId}`,
                method: "DELETE",
                body: {}
            })
        }),

        updateVendorNote: builder.mutation({
            query: ({id, body}) => ({
                url: `/vendor/${id}/note`,
                method: "PATCH",
                body
            })
        }),

        updateVendorEmail: builder.mutation({
            query: ({ id, body }) => ({
                url: `/vendor/${id}/change-email`, 
                method: "PATCH",
                body
            })
        }),
        updateVendorMobile: builder.mutation({
            query: ({ id, body }) => ({
                url: `/vendor/${id}/change-phone`, 
                method: "PATCH",
                body
            })
        }),

        getAllVendorsForExport: builder.mutation({
            query: () => ({
                url: `/vendor/export`,
                method: "GET",
            }),
            transformResponse: (response) => response,
            providesTags: ["vendor"],
        }),

        // ====================================================================
        // INSIGHTS
        // ====================================================================
        getVendorInsights: builder.query({
            query: ({ startDate, endDate }) => {
                let apiUrl = `/vendor/insights`;
                if (startDate) {
                    apiUrl += `?startDate=${startDate}`;
                }
                if (endDate) {
                    apiUrl += `${startDate ? '&' : '?'}endDate=${endDate}`;
                }
                return {
                    url: apiUrl,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response.data,
            providesTags: ['vendorInsights'],
        }),
    }),
});

export const { 
    useGetAllVendorsMutation,
    useGetVendorByIdMutation,
    useCreateVendorMutation,
    useUpdateVendorMutation,
    useDeleteVendorMutation,
    useUpdateVendorEmailMutation,
    useUpdateVendorMobileMutation,
    useGetAllVendorsForExportMutation,

    useActivateVendorMutation,
    useDeactivateVendorMutation,

    useUploadVendorDocumentMutation,
    useRemoveVendorDocumentMutation,

    useUpdateVendorNoteMutation,

    // Insights
    useGetVendorInsightsQuery,
} = vendorAPI;

export default vendorAPI;